import axios from "axios";
export default {
    logoutApiUrl: "/Account/Logout",
    logoutApi: () => axios.get("/Account/Logout"),
    loginApi: (data) => {
        const formData = new FormData();
        formData.append("Login", data.login);
        formData.append("Password", data.password);
        return axios.post("/Account/Login", formData);
    },
    loginEmailApi: (data) => {
        const formData = new FormData();
        formData.append("Email", data.email);
        formData.append("Password", data.password);
        return axios.post("/Account/LoginEmail", formData);
    }
};
